export enum ProfileManageMode {
  new = "new",
  edit = "edit",
}
